import { PasswordInput, Text, Group, Anchor } from "@mantine/core";
import { FC } from "react";

type Props = {
  className: string;
  style?: {};
  others?: any;
  name?: string;
  forgotPassword: CallableFunction;
  onChange?: (...args: any) => any;
  isErrored?: string;
  placeholder?: string;
};
const ForgotPasswordInput: FC<Props> = ({
  className,
  onChange,
  forgotPassword,
  isErrored: _isErrored,
  placeholder = "Enter Your Password",
  ...others
}) => {
  return (
    <div className={className} style={{ paddingTop: "8px", width: "100%", height: "100%" }}>
      <Group justify="space-between" mb={8}>
        <Text component="label" htmlFor="your-password" size="sm" c="#3C4257">
          Password
        </Text>
        <Anchor<"a">
          href="#"
          data-testid="forgot-password-link"
          onClick={(event) => {
            event.preventDefault();
            forgotPassword();
          }}
          sx={(theme) => ({
            paddingTop: 2,
            color: "#338F86",
            fontWeight: 500,
            fontSize: theme.fontSizes.sm,
            // Mantine's Anchor falls back to its own themed link colour
            // (blue) on hover unless told otherwise — the rest-state color
            // above only covers the non-hover state. `&:hover:hover` (not a
            // plain `&:hover`) for the same reason as the NavLink cascade
            // note: doubling the pseudo-class raises specificity enough to
            // beat Mantine's own hover rule, matching the Sign up link's
            // hover treatment (LoginCss.tsx `signUp`).
            "&:hover:hover": {
              color: "#2b7a72",
              textDecoration: "underline",
            },
          })}
        >
          Forgot your password?
        </Anchor>
      </Group>
      <div>
        <PasswordInput
          onChangeCapture={(value) => (onChange ? onChange(value) : "")}
          defaultVisible={false}
          placeholder={placeholder}
          id="your-password"
          size="md"
          {...others}
        />
      </div>
    </div>
  );
};

export default ForgotPasswordInput;
